import * as React from 'react';
import { ComponentProps } from 'react';
import type { Props } from './types';
import DatePicker from './DatePicker';

export default function DatePickerLess(props: ComponentProps<typeof DatePicker> & Props) {
    return <DatePicker variant={'borderless'} suffixIcon={''} allowClear={false} {...props} />;
}
